<template>
    <BasePanel>
        <template #default>
            <!-- eslint-disable vue/no-v-html -->
            <p
                v-if="fairUsePolicy"
                v-html="fairUsePolicy"
            />
            <!-- eslint-enable -->

            <p>
                <NuxtLink
                    :to="`/${fairUsePolicyUri}`"
                    @click.prevent="navigateToFairUsePolicy"
                >
                    Lees ook onze fair use policy
                </NuxtLink>
            </p>

            <BaseButton
                class="button button--secondary button--stretch"
                @click="$emit('close')"
            >
                Begrepen
            </BaseButton>
        </template>
    </BasePanel>
</template>

<script setup lang="ts">
import { useEventsStore } from '~/stores/events';
import { useModalStore } from '~/stores/modal';

defineEmits(['close']);

const eventsStore = useEventsStore();
const modalStore = useModalStore();

const ticketPricing = computed(() => eventsStore.ticketPricing);
const fairUsePolicy = computed(() => {
    let output = null;

    if (ticketPricing.value.type  === ReservationType.PREMIUM) {
        output = eventsStore.fairUsePolicy.premium;
    }

    if (ticketPricing.value.type === ReservationType.EXTRA_CAPACITY) {
        output = eventsStore.fairUsePolicy.extraCapacity;
    }

    if (ticketPricing.value.type === ReservationType.DISCOUNT) {
        output = eventsStore.fairUsePolicy.discount;
    }


    return output
        ? replaceEventTitlePlaceholder(output, eventsStore.activeEvent?.title)
        : null;
});

const fairUsePolicyUri = computed(() => eventsStore.fairUsePolicyUri);

const navigateToFairUsePolicy = async() => {
    modalStore.closeAll();

    await navigateTo(`/${fairUsePolicyUri.value}`);
};
</script>
